import { render, staticRenderFns } from "./PostCreate.vue?vue&type=template&id=e39990a8&scoped=true&"
import script from "./PostCreate.vue?vue&type=script&lang=ts&"
export * from "./PostCreate.vue?vue&type=script&lang=ts&"
import style0 from "./PostCreate.vue?vue&type=style&index=0&id=e39990a8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e39990a8",
  null
  
)

export default component.exports